/* eslint-disable @angular-eslint/no-output-on-prefix */
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ILandmark } from 'src/modules/shared/models/interfaces/landmarks.interface';
import { SentenceTypeEnum } from 'src/modules/shared/models/enums/sentence-type.enum';
import { RobotSentence, RobotWordClick } from 'src/modules/shared/models/robots.model';
import { faDownFromLine, faEdit, faLeftFromLine, faRightFromLine, faUpFromLine } from '@fortawesome/pro-solid-svg-icons';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { debounce, distinctUntilChanged } from 'rxjs/operators';
import { interval } from 'rxjs';

@Component({
  selector: 'hcr-robot-landmark-form',
  templateUrl: './robot-landmark-form.component.html',
  styleUrls: ['./robot-landmark-form.component.sass'],
})
export class RobotLandmarkFormComponent implements OnInit, OnChanges {
  @Input() landmark: ILandmark;
  @Input() selectedWord: RobotWordClick;
  @Output() onCancel: EventEmitter<void> = new EventEmitter();
  @Output() onChange: EventEmitter<ILandmark> = new EventEmitter();
  @Output() onRemove: EventEmitter<void> = new EventEmitter();

  public landmarkForm: FormGroup;

  public icons = {
    upFromLine: faUpFromLine,
    rightFromLine: faRightFromLine,
    downFromLine: faDownFromLine,
    leftFromLine: faLeftFromLine,
    edit: faEdit,
    trash: faTrash,
  };

  public landmarkStates = {
    opened: false,
  };

  private _debounceTime = 350;

  constructor() {
    this.landmarkForm = new FormGroup({
      position: new FormControl('', [Validators.required]),
      text: new FormControl('', [Validators.required]),
      regex: new FormControl(false),
    });
  }

  public changeLandmarkPosition(position: number): void {
    this.landmarkForm.controls['position'].setValue(position);
  }

  public cancel(): void {
    this.onCancel.emit();
  }

  public removeLandmark(): void {
    this.onRemove.emit();
  }

  ngOnInit(): void {
    this.landmarkForm.valueChanges
      .pipe(
        distinctUntilChanged(),
        debounce(() => interval(this._debounceTime))
      )
      .subscribe(() => {
        this.onChange.emit({
          position: this.landmarkForm.controls['position'].value,
          sentence: new RobotSentence({
            text: this.landmarkForm.controls['text'].value,
            polygon: this.selectedWord.polygon,
            identificationThreshold: this.selectedWord.extractionThreshold,
            type: this.landmarkForm.controls['regex'].value ? SentenceTypeEnum.Regex : SentenceTypeEnum.Default,
            pattern: this.landmarkForm.controls['text'].value,
            isDenied: false,
          }),
        });
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.landmark?.currentValue) {
      this.landmarkForm.controls['position'].setValue(this.landmark.position);
      this.landmarkForm.controls['text'].setValue(this.landmark.sentence.text || this.landmark.sentence.pattern);
      this.landmarkForm.controls['regex'].setValue(this.landmark.sentence.type === SentenceTypeEnum.Regex);
    }

    if (changes.selectedWord?.currentValue && !this.selectedWord.landmarks) {
      this.selectedWord.landmarks = [];
    }
  }
}
